<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :submit-btn-text="item && item.id ? 'Update' : 'Submit'"
    :submit-btn-disabled="(!item.id || item.id <= 0) && item.commercial_bundle_items.length < 1"
    :is-submit-btn="!isViewing"
    :full-screen="true"
    :persistent="true"
  >
    <template slot="header">
      <span
        >{{ headlineText() }} Bundle
        {{ item.bundle_number ? `#${item.bundle_number}` : '' }}</span
      >
    </template>
    <template slot="body">
      <v-row>
        <v-col v-if="item && item.status" class="text-center">
          <h3 class="h3">Status</h3>
          <v-chip
            medium
            :color="item && item.status ? item.status.color : 'black'"
            text-color="white"
            class="mt-1"
          >
            {{ item && item.status ? item.status.name : '' }}
          </v-chip>
        </v-col>
        <v-col v-if="item && item.created_at" class="text-center">
          <h3 class="h3">Created At</h3>
          <span class="mt-1 font-weight-bold">{{
            item ? item.created_at : ''
          }}</span>
        </v-col>
        <v-col v-if="item && item.commercial_skid_item && item.commercial_skid_item.commercial_skid && item.commercial_skid_item.commercial_skid.skid_number" class="text-center">
          <h3 class="h3">Skid Number</h3>
          <span class="mt-1 font-weight-bold">{{
            item ? item.commercial_skid_item.commercial_skid.skid_number : ''
          }}</span>
        </v-col>
        <v-col v-if="item && item.commercial_bill_of_lading_item && item.commercial_bill_of_lading_item.bill_of_lading && item.commercial_bill_of_lading_item.bill_of_lading.code" class="text-center">
          <h3 class="h3">Bill Of Lading Code</h3>
          <span class="mt-1 font-weight-bold">{{
            item ? item.commercial_bill_of_lading_item.bill_of_lading.code : ''
          }}</span>
        </v-col>
        <v-col v-if="item && item.created_by_name" class="text-center">
          <h3 class="h3">Created By</h3>
          <span class="mt-1 font-weight-bold">{{
            item ? item.created_by_name : ''
          }}</span>
        </v-col>
        <v-col v-if="item && item.shipped_at" class="text-center">
          <h3 class="h3">Shipped Date</h3>
          <span class="mt-1 font-weight-bold">{{
            item ? item.shipped_at : ''
          }}</span>
        </v-col>
        <v-col v-if="item && item.shipped_by_name" class="text-center">
          <h3 class="h3">Shipped By</h3>
          <span class="mt-1 font-weight-bold">{{
            item ? item.shipped_by_name : ''
          }}</span>
        </v-col>
        <v-col v-if="item && item.received_at" class="text-center">
          <h3 class="h3">Received Date</h3>
          <span class="mt-1 font-weight-bold">{{
            item ? item.received_at : ''
          }}</span>
        </v-col>
        <v-col v-if="item && item.received_by_name" class="text-center">
          <h3 class="h3">Received By</h3>
          <span class="mt-1 font-weight-bold">{{
            item ? item.received_by_name : ''
          }}</span>
        </v-col>
      </v-row>
      <v-row
        align="center"
      >
        <v-col cols="3" class="mt-4 pb-0">
          <v-text-field
            v-model="tagQr"
            autofocus
            :disabled="isViewing"
            @keydown.enter.native.prevent
            @input="qrCodeValueChange"
          />
        </v-col>
        <v-col cols="auto" class="mt-4 pb-0">
          <v-tooltip top>
            <template #activator="{ on, attrs }">
              <div v-on="!tagQr ? on : ''">
                <v-btn
                  v-bind="attrs"
                  color="primary"
                  outlined
                  :disabled="!tagQr || isViewing"
                  @click="addTag"
                  @keyup.enter="addTag"
                >
                  Scan
                </v-btn>
              </div>
            </template>
            <span> Add Finished Good Tag</span>
          </v-tooltip>
        </v-col>
        <v-spacer />
        <v-col class="mt-4 pb-0" cols="auto">
          <span style="font-size: 60px; font-weight: bold; color: #000"
            >Total QTY: {{ item && item.commercial_bundle_items ? item.commercial_bundle_items.length : 0 }}</span
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pt-0">
          <v-card elevation="0" outlined>
            <v-data-table
              :headers="headers"
              :items="item.commercial_bundle_items"
              :height="tableHeight"
              hide-default-footer
              :items-per-page="-1"
              dense
            >
              <template
                v-for="h in headers"
                #[`header.${h.value}`]="{ header }"
              >
                <v-tooltip
                  v-if="h.fullText"
                  :key="h.value"
                  top
                >
                  <template #activator="{ on }">
                    <span v-on="on">{{ header.text }}</span>
                  </template>
                  <span>{{ header.fullText }}</span>
                </v-tooltip>
                <span
                  v-else
                  :key="h.value"
                >
                  {{ h.text }}
                </span>
              </template>
              <template #[`item.finished_good.tag_id`]="{ item }">
                <span style="font-weight: bold">
                  {{ item && item.finished_good && item.finished_good.tag_id ? item.finished_good.tag_id : '-' }}
                </span>
              </template>
              <template #[`item.sequence_number`]="{ item }">
                {{ item && item.finished_good && item.finished_good.tag_id ? extractSequenceNumber(item) : '-' }}
              </template>
              <template #[`item.finished_good.int_color.code`]="{ item }">
                {{ item && item.finished_good && item.finished_good.int_color && item.finished_good.int_color.code ? item.finished_good.int_color.code : '-' }}
              </template>
              <template #[`item.finished_good.ext_color.code`]="{ item }">
                {{ item && item.finished_good && item.finished_good.ext_color && item.finished_good.ext_color.code ? item.finished_good.ext_color.code : '-' }}
              </template>
              <template #[`item.status`]="{ item }">
                <v-chip
                  v-if="item && item.finished_good && item.finished_good.status"
                  small
                  :color="item.finished_good.status.color ? item.finished_good.status.color : '#000000'"
                  text-color="white"
                >
                  {{ item.finished_good.status.name }}
                </v-chip>
              </template>
              <template #[`item.finished_good.sqft`]="{ item }">
                {{ item && item.finished_good && item.finished_good.sqft ? `${item.finished_good.sqft.toFixed(2)} sqft` : '-' }}
              </template>
              <template #[`item.finished_good.width`]="{ item }">
                {{ item && item.finished_good && item.finished_good.type_id !== finishedGoodCommercialTypeIdFrame && item.finished_good.type_id !== finishedGoodCommercialTypeIdSlab && item.finished_good.width ? `${displayInchesWithFraction(item.finished_good.width)}` : '-' }}
              </template>
              <template #[`item.finished_good.height`]="{ item }">
                {{ item && item.finished_good && item.finished_good.type_id !== finishedGoodCommercialTypeIdFrame && item.finished_good.type_id !== finishedGoodCommercialTypeIdSlab && item.finished_good.height ? `${displayInchesWithFraction(item.finished_good.height)}` : '-' }}
              </template>
              <template #[`item.finished_good.length`]="{ item }">
                {{ item && item.finished_good && (item.finished_good.type_id == finishedGoodCommercialTypeIdFrame || item.finished_good.type_id == finishedGoodCommercialTypeIdSlab) &&
                    getLengthFromFinishedGoodComponent(item.finished_good) ? `${displayInchesWithFraction(getLengthFromFinishedGoodComponent(item.finished_good))}`: '-' }}
              </template>
              <template #[`item.finished_good.weight`]="{ item }">
                <!-- <span v-if="item.finished_good.sqft || item.finished_good.type_id === finishedGoodCommercialTypeIdFrame || item.finished_good.type_id === finishedGoodCommercialTypeIdSlab" :style="{ color: getWeightKilograms(item.finished_good) ? '#000000' : 'red', fontWeight: 'bold' }">
                  {{  getWeightKilograms(item.finished_good) ? parseFloat(getWeightKilograms(item.finished_good)).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) : 'Unable to Calculate Weight' }}
                </span> -->
                <span
                  v-if="
                    getWeightKilograms(item.finished_good)
                  "
                  style="font-weight: bold"
                >
                  {{ getWeightKilograms(item.finished_good) ? parseFloat(getWeightKilograms(item.finished_good)).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) : 'Unable to Calculate Weight' }}
                </span>
                <span v-else>
                  <v-tooltip left>
                    <template #activator="{ on }">
                      <span
                        style="color: red; font-weight: bold;"
                        v-on="on"
                      >!</span>
                    </template>
                    <span> Missing {{ getFinishedGoodMissingField(item.finished_good) }}; Unable to calculate weight </span>
                  </v-tooltip>
                </span>
              </template>
              <template #[`item.actions`]="{ item }">
                <v-btn
                  v-if="!isViewing"
                  class="ml-1 mt-1 mb-1"
                  color="error"
                  outlined
                  small
                  @click="removeTag(item)"
                >
                  REMOVE
                </v-btn>
              </template>
              <template slot="body.append">
                <tr>
                  <th />
                  <th />
                  <th />
                  <th />
                  <th />
                  <th />
                  <th />
                  <th />
                  <th class="text-end pr-1">
                    <span style="color: #000000; font-weight: bold; font-size: 14px;">Totals: </span>
                  </th>
                  <th class="text-end">
                    <span style="font-weight: bold; font-size: 14px;">{{ displayInchesWithFraction(getTotalLength()) }}</span>
                  </th>
                  <th class="text-end">
                    <span style="font-weight: bold; font-size: 14px;">{{ parseFloat(getTotalWeightKilograms()).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) }}</span>
                  </th>
                  <th />
                  <th />
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="3"
          class="pl-8"
        >
          <div class="d-flex align-center">
            <v-icon class="mr-2">mdi-briefcase-variant</v-icon>
            <span
              :style="{
              color: isDarkMode ? '' : '#000000',
              fontSize: '18px',
              }">{{ formattedJob }}</span>
          </div>
        </v-col>
        <v-spacer />
        <v-col cols="auto" class="pb-0 pt-0">
          <v-row align="center">
            <v-col class="pr-2 pt-6">
              <span
                :style="{
                  color: isDarkMode ? '#ffffffb3' : '#00000099',
                  fontSize: '16px !important',
                }"
                >Decimal</span
              >
            </v-col>
            <v-col class="pl-0">
              <v-switch
                v-model="uomSwitch"
                hide-details
                class="mt-0 pt-3"
                label="Fraction"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="auto" class="text-end pr-10">
          <span
            :style="{
              color: isDarkMode ? '' : '#000000',
              fontWeight: 'bold',
              fontSize: '18px',
            }"
            >Total Qty:
            {{ item.commercial_bundle_items.length }}</span
          >
        </v-col>
      </v-row>
      <confirm-form ref="confirmForm" />
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import * as FormatHelpers from '@/helpers/FormatHelpers';

export default {
  components: {},
  props: {},
  data: () => ({
    item: null,
    itemDto: {
      id: 0,
      commercial_bundle_id: null,
      commercial_bundle_items: [],
      job_id: null,
    },
    tagQr: null,
    commercialBundleItems: [],

    headers: [
      { text: 'Tag ID', value: 'finished_good.tag_id', width: '10%', sortable: false },
      {
        text: 'Tag #',
        fullText: 'Window Number on Drawing',
        value: 'finished_good.tag_number',
        width: '10%',
        sortable: false,
      },
      {
        text: 'Sequence #',
        value: 'sequence_number',
        width: '5%',
        sortable: false,
      },
      {
        text: 'Work Order',
        value: 'finished_good.work_order',
        width: '5%',
        sortable: false,
      },
      {
        text: 'Reference',
        value: 'finished_good.floor_number',
        width: '15%',
        sortable: false,
      },
      {
        text: 'Type',
        value: 'finished_good.type.name',
        width: '5%',
        sortable: false,
      },
      {
        text: 'Die',
        value: 'finished_good.aluminum_die.code',
        width: '5%',
        sortable: false,
      },
      {
        text: 'Int. Color',
        value: 'finished_good.int_color.code',
        width: '8%',
        sortable: false,
      },
      {
        text: 'Ext. Color',
        value: 'finished_good.ext_color.code',
        width: '8%',
        sortable: false,
      },
      // {
      //   text: 'Square Feet',
      //   value: 'finished_good.sqft',
      //   align: 'end',
      //   width: '10%',
      //   sortable: false,
      // },
      // {
      //   text: 'Width (inches)',
      //   value: 'finished_good.width',
      //   align: 'end',
      //   width: '10%',
      //   sortable: false,
      // },
      // {
      //   text: 'Height (inches)',
      //   value: 'finished_good.height',
      //   align: 'end',
      //   width: '10%',
      //   sortable: false,
      // },
      {
        text: 'Length (inches)',
        value: 'finished_good.length',
        align: 'end',
        width: '10%',
        sortable: false,
      },
      {
        text: 'Weight (kg)',
        value: 'finished_good.weight',
        align: 'end',
        width: '10%',
        sortable: false,
      },
      {
        text: 'Status',
        value: 'status',
        align: 'center',
        width: '10%',
        sortable: false,
      },
      {
        text: 'Actions',
        value: 'actions',
        align: 'end',
        width: '10%',
        sortable: false,
      }
    ],
    tableHeight: 570,
    topSpaceHeight: 470,

    isStreamlineDoorScanning: false,
    loading: false,
    uomSwitch: true,
    timeoutId: null,
    isViewing: false,
    isCommercialBundleQr: false,
    finishedGoodsToReassignFromOtherBundles: [],
    finishedGoodsToReassignFromOtherSkids: [],
    finishedGoodCommercialTypeIdWindow: 1,
    finishedGoodCommercialTypeIdDoor: 2,
    finishedGoodCommercialTypeIdFrame: 3,
    finishedGoodCommercialTypeIdSlab: 4,
    productionScheduleStatusIdInProgress: 1,
    jobSubClassIdCommDoor: 7,
  }),
  computed: {
    ...mapState({
      user: (state) => state.user,
      isDarkMode: 'isDarkMode',
    }),
    ...mapGetters([
      'businessRulesGetBoolean',
    ]),
    formattedJob() {
      if (!this.item?.job) return 'No Assigned Job';

      const { code, name, reference } = this.item.job;
      return `${code} - ${name}${reference ? `; ${reference}` : ''}`;
    },
  },
  created() {
    this.item = { ...this.itemDto };
    this.init();
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
    this.updateTableHeight();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    async init() {
      this.isStreamlineDoorScanning = this.businessRulesGetBoolean('Streamline Door Scanning'); 
    },

    async open(id = null, isViewing = false, tagQr = null, isCommercialBundleQr = false) {
      this.$bus.$emit('loading');
      this.isViewing = isViewing;
      this.isCommercialBundleQr = isCommercialBundleQr;
      this.finishedGoodsToReassignFromOtherBundles = [];
      this.finishedGoodsToReassignFromOtherSkids = [];
      // if (this.isCommercialBundleQr) {
      //   id = this.extractIdFromQrCode(id);
      //   if (!id) {
      //     this.$refs.dialogBox.close();
      //     this.$bus.$emit('loading-stop');
      //     this.$bus.$emit('showError', 'QR code is incorrect');
      //     return;
      //   }
      // }
      if (id) {
        const request = {
          id,
        };
        await this.get(request);
      }
      else if (tagQr) {
        const request = {
          bundle_number: tagQr,
        };
        await this.get(request);
      } else {
        this.item = JSON.parse(JSON.stringify(this.itemDto));
      }
      await this.$refs.dialogBox.open(); // for some reason need to add await, otherwise user's location won't be set in v-autocomplete by default
      this.$bus.$emit('loading');
    },

    async get(requestData) {
      const submitModel = {
        filters: requestData,
      };
      const res = await this.$api.commercialBundle.read(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res || res.length === 0) {
        this.$bus.$emit('showError', 'Bundle not found');
        return;
      }
      const firstIndex = 0;
      this.item = res.data[firstIndex];
    },

    async submit() {
      this.$bus.$emit('loading');
      let res = false;

      if (this.finishedGoodsToReassignFromOtherBundles.length > 0) {
        this.item.finished_goods_to_reassign_from_other_bundles = this.finishedGoodsToReassignFromOtherBundles;
      }

      if (this.finishedGoodsToReassignFromOtherSkids.length > 0) {
        this.item.finished_goods_to_reassign_from_other_skids = this.finishedGoodsToReassignFromOtherSkids;
      }

      if (this.item.id) {
        res = await this.$api.commercialBundle.update(this.item);
      } else {
        res = await this.$api.commercialBundle.store(this.item);
      }
      if (!res) {
        this.$bus.$emit('loading');
        this.$bus.$emit('showError');
        return false;
      }
      this.$bus.$emit('loading');
      this.$bus.$emit('showSuccess');
      this.$emit('success');
      return true;
    },

    async addTag() {
      this.$bus.$emit('loading');

      const submitModel = {
        filters: {
          tag_id: this.tagQr,
        },
      };
      const res = await this.$api.finishedGoodCommercial.read(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res || res.length === 0) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Tag is not found or incorrect', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      const finishedGood = res[0];
      if (this.isScanned(finishedGood)) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Tag has already been scanned', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      if (finishedGood.type_id === this.finishedGoodCommercialTypeIdDoor) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Tag is a door - unable to add to bundle', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      if (this.isDoorComponent(finishedGood) && this.isStreamlineDoorScanning) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Tag is a door component - unable to add to bundle while Streamline Door Scanning is enabled', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      //need to check if tag is a window and if it is, block
      if (finishedGood.type_id === this.finishedGoodCommercialTypeIdWindow) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Tag is a window - unable to add to bundle', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }


      const isSameJobData = this.isSameJob(finishedGood);
      if (!isSameJobData.is_same_job) {
        // const firstItemJobName = isSameJobData.first_item_job_name ? isSameJobData.first_item_job_name : 'N/A';
        // const addedItemJobName = isSameJobData.added_item_job_name ? isSameJobData.added_item_job_name : 'N/A'; 
        // const errorMessage = `Tag is from a different job (${firstItemJobName} vs ${addedItemJobName})`;
        const errorMessage = 'Tag is from a different job';
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', errorMessage, null, 'xl', 5000);
        this.tagQr = null;
        return;
      }

      const bundleNumber = await this.isTagAssignedToBundle(finishedGood);
      if (bundleNumber === undefined) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Error determining if tag is assigned to another bundle', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (bundleNumber) {
        // this.$bus.$emit('loading-stop');
        // this.$bus.$emit('showError', `Window is under - Bundle #${bundleId}`, null, 'xl', 2500);
        // this.tagQr = null;
        // return;
        this.$bus.$emit('loading-stop');
        const confirm = await this.$refs.confirmForm.open({
          title: `Tag is under - Bundle #${bundleNumber} - Would you like to move it?`,
        });
        if (!confirm) {
          this.tagQr = null;
          return;
        }
        this.finishedGoodsToReassignFromOtherBundles.push(finishedGood); 
      }
      const skidNumber = await this.isTagAssignedToSkid(finishedGood);
      if (skidNumber === undefined) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Error determining if tag is assigned to a skid', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (skidNumber) {
        this.$bus.$emit('loading-stop');
        const confirm = await this.$refs.confirmForm.open({
          title: `Tag is under - Skid #${skidNumber} - Would you like to move it?`,
        });
        if (!confirm) {
          this.tagQr = null;
          return;
        }
        this.finishedGoodsToReassignFromOtherSkids.push(finishedGood); 
      }
      const billOfLadingId = await this.isTagAssignedToBillOfLading(finishedGood);
      if (billOfLadingId === undefined) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Error determining if tag is assigned to a bill of lading', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (billOfLadingId) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', `Tag is under - Bill Of Lading #${billOfLadingId}`, null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      // if (finishedGood.commercial_schedule == null || finishedGood.commercial_schedule == undefined) {
      //   this.$bus.$emit('loading-stop');
      //   this.$bus.$emit('showError', 'Finished Good is not part of a commercial schedule', null, 'xl', 2500);
      //   this.tagQr = null;
      //   return;
      // }
      if (finishedGood.commercial_schedule && finishedGood.commercial_schedule.status_id !== this.productionScheduleStatusIdInProgress) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Finished Good\'s Commercial Schedule status is not set to In Progress (Current)', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (finishedGood.status_id === this.finishedGoodStatusIdShipped) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Tag has already been shipped', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (finishedGood.status_id === this.finishedGoodStatusIdReceived) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Tag has already been received', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (finishedGood.status_id === this.finishedGoodStatusIdQuarantined) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Tag has been quarantined', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (!finishedGood.type) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Finished good type is not set - unable to calculate weight', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      this.item.commercial_bundle_items.unshift({ finished_good: finishedGood });

      if (this.item.job_id === null) {
        const jobId = finishedGood.commercial_schedule && finishedGood.commercial_schedule.job_id
          ? finishedGood.commercial_schedule.job_id
          : null;

        const job = finishedGood.commercial_schedule && finishedGood.commercial_schedule.job
          ? finishedGood.commercial_schedule.job
          : null;

        this.$set(this.item, 'job_id', jobId);
        this.$set(this.item, 'job', job);
      }

      this.$bus.$emit('loading-stop');
      this.$bus.$emit('showSuccess', null, null, 2500);
      this.tagQr = null;
    },

    isScanned(finishedGood) {
      const index = this.item.commercial_bundle_items.findIndex(
        (x) => x.finished_good.id === finishedGood.id,
      );
      return index >= 0;
    },

    isDoorComponent(finishedGood) {
      const subClassId = finishedGood?.commercial_schedule?.job?.sub_class_id;
      return subClassId === this.jobSubClassIdCommDoor;
    },

    isSameJob(item) {
      const firstItem = this.item.commercial_bundle_items?.[0];

      const firstItemJob =
        firstItem?.finished_good?.commercial_schedule?.job ?? null;

      const addedItemJob =
        item?.commercial_schedule?.job ?? null;

      const firstItemJobName = FormatHelpers.getJobName(firstItemJob);
      const addedItemJobName = FormatHelpers.getJobName(addedItemJob);

      const isSameJob =
        firstItemJob && addedItemJob
          ? firstItemJob.id === addedItemJob.id
          : true;

      return {
        is_same_job: isSameJob,
        first_item_job_name: firstItemJobName,
        added_item_job_name: addedItemJobName,
      };
    },

    async isTagAssignedToBundle(finishedGood) {
      const readModel = {
        filters: {
          finished_good_commercial_id: finishedGood.id,
        },
      };

      const res = await this.$api.commercialBundleItem.read(readModel);
      const cancelCode = 3001;
      if (res === cancelCode) return undefined;
      if (!res || !res.data) {
        return undefined;
      }

      if (res.total >= 1) {
        const firstIndex = 0;
        return res.data[firstIndex].commercial_bundle?.bundle_number;
      }

      return null;
    },

    async isTagAssignedToSkid(finishedGood) {
      const readModel = {
        filters: {
          finished_good_commercial_id: finishedGood.id,
        },
      };

      const res = await this.$api.commercialSkidItem.read(readModel);
      const cancelCode = 3001;
      if (res === cancelCode) return undefined;
      if (!res || !res.data) {
        return undefined;
      }

      if (res.total >= 1) {
        const firstIndex = 0;
        return res.data[firstIndex].commercial_skid?.skid_number;
      }

      return null;
    },

    async isTagAssignedToBillOfLading(finishedGood) {
      const readModel = {
        filters: {
          finished_good_commercial_id: finishedGood.id,
        },
      };

      const res = await this.$api.commercialBillOfLading.read(readModel);
      const cancelCode = 3001;
      if (res === cancelCode) return undefined;
      if (!res || !res.data) {
        return undefined;
      }

      if (res.total >= 1) {
        const firstIndex = 0;
        return res.data[firstIndex].id;
      }

      return null;
    },

    async removeTag(item) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to remove this record?',
      });
      if (!confirm) return;
      const itemIndex = this.item.commercial_bundle_items.findIndex((x) => x.finished_good.id === item.finished_good.id);
      if (itemIndex >= 0) {
        this.item.commercial_bundle_items.splice(itemIndex, 1);
      }
    },

    getLengthFromFinishedGoodComponent(finishedGood) {
      if (
        !finishedGood ||
        (finishedGood.type_id !== this.finishedGoodCommercialTypeIdFrame && finishedGood.type_id !== this.finishedGoodCommercialTypeIdSlab)
      ) {
        return 0;
      }
      if (finishedGood.width != null) {
        return finishedGood.width;
      }
      if (finishedGood.height != null) {
        return finishedGood.height;
      }
    },

    getWeightKilograms(finishedGood) {
      if (finishedGood.type_id === this.finishedGoodCommercialTypeIdFrame || finishedGood.type_id === this.finishedGoodCommercialTypeIdSlab) {
        // For frames, weight is calculated differently
        const length = this.getLengthFromFinishedGoodComponent(finishedGood);
        console.log('Length for weight calculation:', length);
        if (!length) return null;
        console.log('Weight ratio for frame/slab:', finishedGood.aluminum_die.weight_ratio);
        if (!finishedGood.aluminum_die || !finishedGood.aluminum_die.weight_ratio) return null;
        const weight = length * finishedGood.aluminum_die.weight_ratio;
        console.log('Weight for finished good:', weight);
        return weight;
      }
      return finishedGood.sqft * finishedGood.type.weight_ratio;
    },

    getTotalSqft() {
      return this.item.commercial_bundle_items.reduce((acc, item) => acc + parseFloat(item.finished_good.sqft ? item.finished_good.sqft : 0), 0);
    },

    getTotalWidth() {
      return this.item.commercial_bundle_items.reduce((acc, item) => acc + parseFloat(item.finished_good.width && item.finished_good.type_id !== this.finishedGoodCommercialTypeIdFrame && item.finished_good.type_id !== this.finishedGoodCommercialTypeIdSlab ? item.finished_good.width : 0), 0);
    },

    getTotalHeight() {
      return this.item.commercial_bundle_items.reduce((acc, item) => acc + parseFloat(item.finished_good.height && item.finished_good.type_id !== this.finishedGoodCommercialTypeIdFrame && item.finished_good.type_id !== this.finishedGoodCommercialTypeIdSlab ? item.finished_good.height : 0), 0);
    },

    getTotalLength(){
      let totalLength = this.item.commercial_bundle_items.reduce((acc, item) => {
        let accLength = acc;
        let itemLength = 0
        if (item.finished_good.type_id == this.finishedGoodCommercialTypeIdFrame || item.finished_good.type_id === this.finishedGoodCommercialTypeIdSlab) {
          itemLength = this.getLengthFromFinishedGoodComponent(item.finished_good);
        }
        // acc + parseFloat(item.finished_good.height && item.finished_good.type_id == this.finishedGoodCommercialTypeIdFrame ? item.finished_good.height : 0)
        return accLength + itemLength;
      }, 0);
      return totalLength;
    },

    // getTotalWeightKilograms() {
    //   return this.item.bill_of_lading_items.reduce((acc, item) => acc + (parseFloat(item.finished_good.type.weight_ratio ? item.finished_good.type.weight_ratio : 0) * parseFloat(item.finished_good.sqft ? item.finished_good.sqft : 0)), 0);
    // },

    getTotalWeightKilograms() {
      const totalWeightKilograms = this.item.commercial_bundle_items.reduce((acc, item) => acc + (this.getWeightKilograms(item.finished_good) || 0), 0);
      return totalWeightKilograms;
    },

    getAllTotalWeightKilograms() {
      let total = this.getTotalWeightKilograms();
      const extraItemsTotalWeight = this.$refs.billOfLadingExtraItemForm ? this.$refs.billOfLadingExtraItemForm.getTotalWeightKilograms() : 0;
      total += extraItemsTotalWeight;
      return total;
    },

    getAllTotalWeightPounds() {
      return this.getAllTotalWeightKilograms() * 2.20462;
    },

    convertToFraction(decimal) {
      // check if  a decimal number has numbers after the decimal point
      const decimalString = decimal.toString();
      const decimalPointIndex = decimalString.indexOf('.');

      if (decimalPointIndex === -1) {
        return decimal;
      }
      //

      const fractions = {
        0.0625: '1/16',
        0.125: '1/8',
        0.1875: '3/16',
        0.25: '1/4',
        0.3125: '5/16',
        0.375: '3/8',
        0.4375: '7/16',
        0.5: '1/2',
        0.5625: '9/16',
        0.625: '5/8',
        0.6875: '11/16',
        0.75: '3/4',
        0.8125: '13/16',
        0.875: '7/8',
        0.9375: '15/16',
      };

      // If the decimal is an exact match to any fraction, return the fraction directly
      if (decimal in fractions) {
        return fractions[decimal];
      }

      const wholeNumber = Math.floor(decimal);
      // eslint-disable-next-line no-param-reassign
      decimal -= wholeNumber; // Remove the whole number part

      let closestFraction = Object.keys(fractions)[0];

      // eslint-disable-next-line no-restricted-syntax
      for (const fraction of Object.keys(fractions)) {
        if (
          Math.abs(decimal - fraction) < Math.abs(decimal - closestFraction)
        ) {
          closestFraction = fraction;
        }
      }

      if (wholeNumber > 0) {
        return `${wholeNumber} - ${fractions[closestFraction]}"`;
      }
      return fractions[closestFraction];
    },

    displayInchesWithFraction(inches) {
      // Convert height to the raw number with rounding
      const raw = Math.round(inches / 0.0625) * 0.0625;

      // Extract the whole number part
      const wholeNumber = Math.floor(raw);

      // Calculate the decimal part
      const decInput = parseFloat((raw - wholeNumber).toFixed(4));

      // Initialize numerator and denominator
      let numerator = 1;
      let denominator = 1;

      // Calculate the fraction
      let decimalFraction = numerator / denominator;
      while (decimalFraction !== decInput) {
        if (decimalFraction < decInput) {
          numerator += 1;
        } else {
          denominator += 1;
          numerator = Math.floor(decInput * denominator);
        }
        decimalFraction = numerator / denominator;
      }

      // Create the final output string
      let result = '';
      if (wholeNumber > 0) {
        result += `${wholeNumber}"`;
      }

      if (numerator > 0) {
        result += `-${numerator}/${denominator}''`;
      }

      return result;
    },

    convertDateFormat(inputDate) {
      // Parse the input date
      const date = new Date(inputDate);

      // Format the date as "YYYY-MM-DD h:mm a" (e.g., 2023-10-24 9:25 PM)
      const formattedDate = date.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });

      return formattedDate;
    },

    qrCodeValueChange() {
      if (!this.tagQr) return;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.addTag();
      }, 700);
    },

    extractSequenceNumber(item) {
      const tagId = item?.finished_good?.tag_id;
      if (!tagId) return '-';

      const parts = tagId.split('-');
      return parts.length > 1 ? parts[parts.length - 1] : '-';
    },

    getFinishedGoodMissingField(finishedGood) {
      if (!finishedGood) return null;

      if (finishedGood.type_id === this.finishedGoodCommercialTypeIdWindow || finishedGood.type_id === this.finishedGoodCommercialTypeIdDoor) return 'sqft';

      if (
        (finishedGood.type_id === this.finishedGoodCommercialTypeIdFrame ||
          finishedGood.type_id === this.finishedGoodCommercialTypeIdSlab) 
      ) {
        console.log('finishedGood in getFinishedGoodMissingField: ', finishedGood);
        if (!this.getLengthFromFinishedGoodComponent(finishedGood)) return 'length';
        console.log('finishedGood aluminum die in getFinishedGoodMissingField: ', finishedGood.aluminum_die);
        console.log('finishedGood aluminum die weight ratio in getFinishedGoodMissingField: ', finishedGood.aluminum_die ? finishedGood.aluminum_die.weight_ratio : 'no aluminum die');
        if (!finishedGood.aluminum_die) return 'aluminum die';
        if (!finishedGood.aluminum_die.weight_ratio) return 'aluminum die weight ratio';
      }

      return 'field';
    },

    headlineText() {
      if (this.item.id) {
        return 'Update';
      }
      return 'Create';
    },

    submitBtnText() {
      if (this.item.id) {
        return 'Update';
      }
      return 'Submit';
    },

    isSubmitBtn() {
      if (this.isViewing) {
        return false;
      }
      return true;
    },

    extractIdFromQrCode(qrCode) {
      const match = qrCode.match(/^b(0*[^0]\d*)/i);
      return match ? match[1] : false;
    },

    onResize() {
      this.tableHeight = Math.floor((window.innerHeight * (0.75))) - this.topSpaceHeight;
    },

    updateTableHeight() {
      this.tableHeight = Math.floor((window.innerHeight)) - this.topSpaceHeight;
    },
  },
};
</script>
